var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdbc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 128,
    fill: "#0052FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.7 39v47.117c-15.872 2.361-25.007 12.707-25.007 25.113 0 15.862 10.401 22.451 25.155 25.013l8.95 1.587c8.345 1.464 12.336 2.562 12.336 8.663 0 5.856-4.475 10.493-14.029 10.493-9.434 0-15.239-4.149-15.239-12.568H94c0 14.154 10.522 24.281 26.848 26.478v16.35h14.755v-16.472c15.48-2.441 25.397-12.08 25.397-25.868 0-16.716-11.61-22.572-25.881-24.768l-8.587-1.343c-7.619-1.22-11.851-2.928-11.851-9.151 0-4.88 3.628-9.639 12.819-9.639 9.554 0 13.545 4.637 13.545 10.859h18.867c-.242-11.81-8.673-22.042-24.212-24.63V39.116c45.586 4.14 81.3 42.465 81.3 89.13 0 49.429-40.071 89.5-89.5 89.5-49.43 0-89.5-40.071-89.5-89.5C38 81.104 74.447 42.475 120.7 39Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdbc);
export default __webpack_public_path__ + "static/media/usdbc.94a15ad6621982494a56441cab312772.svg";
export { ForwardRef as ReactComponent };